var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Profile",attrs:{"title":_vm.name},on:{"click":_vm.onClick}},[_c('Icon',{staticClass:"Profile__icon",attrs:{"name":"user","color":"white"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }